import {
  BodyText,
  Col,
  Container,
  HeadingText,
  Row,
} from '@paypalcorp/pp-react'
import React, { useEffect } from 'react'
import * as styles from './createSuccessContent.css'
import { useLocalizedContent } from '../../hooks/useLocalizedContent'
import { Message } from '@paypalcorp/worldready-react'
import ShareGroupButtons from '../../components/ShareGroupButtons'
import { tracking } from '../../lib/analytics/fpti'
import Events from '../../lib/analytics/eventTags.js'
import serverData from '../../utils/server-data'

const CreateSuccessContent = ({
  shareLink,
  groupId,
}: {
  shareLink: string
  groupId: string
}) => {
  const { getContent } = useLocalizedContent()
  useEffect(() => {
    tracking(
      Events.p2p_pools_create_success_sheet_shown({
        source: serverData.trackingParameters.externalSource,
        page_variant: 'creator',
        pool_id: groupId,
      }),
    )
  }, [])

  return (
    <Container className={styles.contentContainer}>
      <Row>
        <Col>
          <HeadingText
            as="h1"
            size="lg"
            className={styles.succesHeading}
            data-testid="successHeading"
          >
            <Message id="create.success.heading" />
          </HeadingText>
        </Col>
      </Row>
      <Row>
        <Col>
          <BodyText
            as="p"
            className={styles.succesSubHeading}
            data-testid="successSubheading"
          >
            <Message id="create.success.subheading" />
          </BodyText>
        </Col>
      </Row>
      <Row>
        <Col>
          <ShareGroupButtons
            shareLink={shareLink}
            isAdmin={true}
            isPayPalUser={true}
            copySuccessfulMessage={getContent('create.success.linkCopied')}
            groupId={groupId}
            isFromCreate={true}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default CreateSuccessContent
